import { RadioButton } from "@commonlibs";
import styled, { css } from "styled-components";

export const RadioButtonRoot = styled(RadioButton)(
    () => css`
        .RadioButton {
            min-width: 18px;
        }
    `,
);
